import { toRefs } from 'vue';
import { getKeycloak } from './keycloak';
import { state } from './state';
import { isNil } from './utils';
export const useKeycloak = () => {
    return Object.assign(Object.assign({}, toRefs(state)), { keycloak: getKeycloak(), hasRoles: (roles) => !isNil(roles) && state.isAuthenticated && roles.every(role => state.roles.includes(role)), hasResourceRoles: (roles, resource) => !isNil(roles) &&
            !isNil(resource) &&
            state.isAuthenticated &&
            !isNil(state.resourceRoles) &&
            !isNil(state.resourceRoles[resource]) &&
            roles.every(role => state.resourceRoles[resource].includes(role)) });
};
//# sourceMappingURL=composable.js.map